import _merge from "lodash/merge";
import React from 'react';
import cn from 'classnames';
import { MuiThemeProvider as MuiV0ThemeProvider } from 'material-ui/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { forceRedirectToPath } from 'swag-common/business-logic/redirect-wrapper-state';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { variables } from 'swag-client-common/styles/variables-js';
import { theme, themeV0 } from '../../styles/mui-themes';
import './reset.scss';
import './normalize.scss';
import classes from './root.scss';
const themeExtensionV0 = {
  palette: {
    primary1Color: variables.colorMainBlue,
    accent1Color: '#ff59a7'
  },
  raisedButton: {
    primaryColor: variables.colorMainBlue,
    secondaryColor: '#ff59a7'
  },
  toggle: {
    thumbOnColor: variables.colorMainBlue
  },
  slider: {
    selectionColor: '#ff59a7',
    rippleColor: '#ff59a7'
  },
  chip: {
    deleteIconColor: '#ff59a7'
  },
  datePicker: {
    selectColor: '#00c1ff',
    headerColor: '#00c1ff'
  }
};
const extendedThemeV0 = _merge(themeV0, themeExtensionV0);
const Root = props => {
  const {
    children,
    isGiveawayFeesPage,
    isHomePage
  } = props;

  /**
   * Redirect to another bundle
   */
  if (!children && isHomePage) {
    forceRedirectToPath(APP_ROUTES.HOME);
    return null;
  }
  const onFocus = () => {
    if (props.isLoggedIn) {
      props.onWindowFocus();
    }
  };
  React.useEffect(() => {
    window.addEventListener('focus', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.root, {
      [classes.rootAvoidOverflow]: isGiveawayFeesPage
    })
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(MuiV0ThemeProvider, {
    muiTheme: extendedThemeV0
  }, children)));
};
export default Root;